var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRamiUsoSolo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000073682446921104660260000004295450966031490461_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 394.3 59.3",
    style: {
      enableBackground: "new 0 0 394.3 59.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FEBE10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "29.6,36.8 35.6,44.6 46.1,30.3 54.1,30.3 54.1,2.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 3,
    className: "st0",
    width: 9.6,
    height: 42.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.8,
    y: 3,
    className: "st0",
    width: 9.6,
    height: 42.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "81.3,45.2 71.7,45.2 71.7,9.3 81.4,18.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "100.6,45.2 110.2,45.2 110.2,9.3 100.8,18.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "71.7,3 82.4,3 90.8,13.6 99.8,2.9 110.2,3 110.2,6.7 90.8,26.3 71.7,6.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,13.2L34.2,45H21.8L0.1,17.1V2.9h20.2c0,0,10.9,0.5,11.9,13.7c0,0,0.6,9.7-7.4,13.4l-7-8.9 c0,0,3.8,0.6,3.8-3.8c0,0,0-3.9-3.6-4.1L9.9,13.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,19.2 9.8,31.9 9.9,45 0.1,45  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamiUsoSolo);
export default __webpack_public_path__ + "static/media/rami-uso-solo.1e98e120bc91f8c95fdd0a252ca3310d.svg";
export { ForwardRef as ReactComponent };